// SECTION: Nostr Data
// TAG: data, nostr, relay, identity
// NOSTR: npub1qahm6ee8jklm58us2zzthczaemjfx74pmwv4ctu86ctw5rmnlr2qgcaz7n

import { NAMESPACE_AGENTS, nip05For } from './namespaceRegistry.js'

export const NOSTR_PUBKEY = "npub1qahm6ee8jklm58us2zzthczaemjfx74pmwv4ctu86ctw5rmnlr2qgcaz7n"
export const NOSTR_HEX_PUBKEY = "076fbd672795bfba1f905084bbe05dcee4937aa1db995c2f87d616ea0f73f8d4"

export const RELAYS = [
  "wss://relay.damus.io",
  "wss://nos.lol",
  "wss://relay.snort.social",
  "wss://relay.nostr.band",
]

/** Static "known as" context for each relay — descriptive, not live. Live status is pinged separately. */
export const RELAY_META = {
  "wss://relay.damus.io": {
    knownFor: "Damus iOS client default relay",
    operator: "Damus",
  },
  "wss://nos.lol": {
    knownFor: "Long-running popular public relay",
    operator: "Community-run",
  },
  "wss://relay.snort.social": {
    knownFor: "Snort web client relay",
    operator: "Snort",
  },
  "wss://relay.nostr.band": {
    knownFor: "Search + archival relay (Nostr.band)",
    operator: "Nostr.band",
  },
}

export const AGENT_AVATARS = Object.fromEntries(
  NAMESPACE_AGENTS.filter((a) => a.avatar).map((a) => [a.name, a.avatar])
)

export const AGENTS = NAMESPACE_AGENTS.map((a) => ({
  name: a.name,
  local: a.local,
  nip05: nip05For(a.local),
  role: a.role,
  avatar: a.avatar,
  signing: a.signing,
  // Every agent has a live LNURL-pay address at <local>@giveabit.io (verified
  // server-side via .well-known/lnurlp/<local>). Used for NIP-57 zap buttons.
  lud16: `${a.local}@giveabit.io`,
  ...(a.signing === 'org-live' ? { pubkey: NOSTR_PUBKEY } : {}),
}))

/** Agents available in Nostr DM picker — Kimi only until others are live. */
export const DM_AGENTS = AGENTS.filter((a) => a.name === 'Kimi')